module.exports = __webpack_public_path__ + "img/bgphone.b38203cd.png";